import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=1ecfd694"
import script from "./Breadcrumb.ts?vue&type=script&lang=ts&external"
export * from "./Breadcrumb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports